module.exports = require("watchpack");


//////////////////
// WEBPACK FOOTER
// external "watchpack"
// module id = 131
// module chunks = 0